import withFeatureBranch from '@wix/da-react-context/pkg/flags/withFeatureBranch';
import SelectField from './SelectField';
import NativeSelectField from './NativeSelectField';

const SelectFieldWithFeatureBranch = withFeatureBranch({
  ds_native_select: NativeSelectField,
})(SelectField);

export default SelectFieldWithFeatureBranch;
export type { Props } from './SelectField';
export { SelectField, NativeSelectField };
